import { StyleSheet } from 'aphrodite';
import { THEME } from '../../components-v2/Theme/theme';

export const styleSheet = StyleSheet.create({
	modalContainer: {
		width: '400px',
		maxWidth: '90vw',
	},
	modalTitle: {
		fontSize: THEME.typography.fontSizes.lg,
		fontWeight: THEME.typography.fontWeights.bold,
		color: THEME.colors.text.main,
		fontFamily: THEME.typography.fontFamilies.lexend,
		marginBottom: THEME.spacing.sm,
	},
	modalDescription: {
		fontSize: THEME.typography.fontSizes.sm,
		color: THEME.colors.text.light,
		fontFamily: THEME.typography.fontFamilies.lexend,
		marginBottom: THEME.spacing.md,
	},
	content: {
		padding: `${THEME.spacing.md}px 0`,
	},
	dropdownContainer: {
		display: 'flex',
		flexDirection: 'column',
		gap: `${THEME.spacing.sm}px`,
	},
	label: {
		fontSize: THEME.typography.fontSizes.sm,
		fontWeight: THEME.typography.fontWeights.standard,
		color: THEME.colors.text.main,
		fontFamily: THEME.typography.fontFamilies.lexend,
	},
	dropdownTrigger: {
		width: '100%',
		minHeight: '40px',
		padding: `${THEME.spacing.sm}px ${THEME.spacing.md}px`,
		border: `1px solid ${THEME.colors.border.main}`,
		borderRadius: THEME.common.borderRadius,
		backgroundColor: THEME.colors.background.light,
		fontSize: THEME.typography.fontSizes.sm,
		fontFamily: THEME.typography.fontFamilies.lexend,
		color: THEME.colors.text.main,
		cursor: 'pointer',
		display: 'flex',
		alignItems: 'center',
		justifyContent: 'space-between',
		':hover': {
			borderColor: THEME.colors.hover.main,
		},
		':focus': {
			borderColor: THEME.colors.primary.main,
			outline: `2px solid ${THEME.colors.primary.light}`,
			outlineOffset: '2px',
		},
	},
	selectedItem: {
		backgroundColor: THEME.colors.primary.light,
		color: THEME.colors.primary.main,
		fontWeight: THEME.typography.fontWeights.standard,
	},
	loadingItem: {
		color: THEME.colors.text.light,
		fontStyle: 'italic',
		cursor: 'default',
		':hover': {
			backgroundColor: 'transparent',
		},
	},
	footer: {
		display: 'flex',
		justifyContent: 'flex-end',
		gap: `${THEME.spacing.sm}px`,
		marginTop: THEME.spacing.lg,
	},
	cancelButton: {
		// Additional styles can be added if needed
	},
	continueButton: {
		// Additional styles can be added if needed
	},
});
